import { motion } from "framer-motion";

const stats = [
  { k: "0", v: "Animal-derived inputs" },
  { k: "100%", v: "Botanical origin" },
  { k: "1", v: "Closed-loop ecosystem" },
  { k: "∞", v: "Cruelty-free future" },
];

export const Vision = () => {
  return (
    <section
      id="vision"
      data-testid="vision-section"
      className="relative py-24 md:py-40 overflow-hidden"
    >
      {/* Soft grid */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-2"
        >
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#10B981] flex items-center gap-3">
            <span className="h-px w-6 bg-[#10B981]" />
            02 / Vision
          </div>
        </motion.div>

        <div className="lg:col-span-10">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="font-display text-4xl sm:text-6xl lg:text-7xl tracking-tighter font-light text-white leading-[1]"
          >
            Beyond extraction.
            <br />
            <span className="italic font-extralight text-white/60">
              Beyond synthesis<span className="text-[#10B981]">.</span>
            </span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="mt-12 max-w-3xl font-body text-base md:text-xl text-white/70 leading-[1.7]"
          >
            The world is tired of harsh chemicals and animal-derived
            compromises. Colossus has engineered a proprietary, closed-loop
            ecosystem that redefines purity. Born entirely from natural
            botanical origins, we provide a cruelty-free future for the Pharma
            and Food industries.{" "}
            <span className="text-white">
              Our process is a trade secret; our results are a global benchmark.
            </span>
          </motion.p>

          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/[0.06] border border-white/[0.06]">
            {stats.map((s, i) => (
              <motion.div
                key={s.v}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 * i }}
                className="bg-[#050907] p-6 md:p-8 hover:bg-[#0a1410] transition-colors"
                data-testid={`vision-stat-${i}`}
              >
                <div className="font-display text-4xl md:text-5xl font-light text-[#10B981]">
                  {s.k}
                </div>
                <div className="mt-3 text-[11px] uppercase tracking-[0.2em] text-white/50">
                  {s.v}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Vision;
